import { apiClient } from './client';
import { API_ENDPOINTS } from './config';
import { User } from '@/types';

export interface CreditsResponse {
  credits: number;
}

export interface ConsumeCreditsRequest {
  amount: number;
}

export interface ConsumeCreditsResponse {
  credits: number;
  success: boolean;
}

export interface CreditUsageItem {
  id: string;
  chatId: string | null;
  totalTokens: number;
  creditsConsumed: number;
  createdAt: string;
}

export interface CreditUsageResponse {
  items: CreditUsageItem[];
  nextCursor: string | null;
}

export interface UpdateUserRequest {
  name?: string;
  email?: string;
  password?: string;
}

export interface SetCurrentWorkspaceRequest {
  workspaceId: string | null;
}

export const usersApi = {
  async getCredits(): Promise<CreditsResponse> {
    return await apiClient.get<CreditsResponse>(API_ENDPOINTS.USERS.CREDITS);
  },

  async getCreditUsage(params?: {
    limit?: number;
    cursor?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<CreditUsageResponse> {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.cursor) search.set('cursor', params.cursor);
    if (params?.dateFrom) search.set('dateFrom', params.dateFrom);
    if (params?.dateTo) search.set('dateTo', params.dateTo);
    const q = search.toString();
    return await apiClient.get<CreditUsageResponse>(
      `${API_ENDPOINTS.USERS.CREDITS_USAGE}${q ? `?${q}` : ''}`
    );
  },

  async consumeCredits(amount: number): Promise<ConsumeCreditsResponse> {
    return await apiClient.post<ConsumeCreditsResponse>(
      API_ENDPOINTS.USERS.CONSUME_CREDITS,
      { amount }
    );
  },

  async updateMe(data: UpdateUserRequest): Promise<User> {
    return await apiClient.patch<User>(API_ENDPOINTS.USERS.ME, data);
  },

  async setCurrentWorkspace(workspaceId: string | null): Promise<User> {
    return await apiClient.post<User>(API_ENDPOINTS.USERS.SET_WORKSPACE, { workspaceId });
  },
};
